import { SecurityGuard } from "@duosoftbg/nacid-components";
import ServiceConfigWrapperPage from "../views/pages/ServiceConfigWrapperPage";
import { rudiAdditionalDocServiceConfig } from "../config/servicesConfig";
import React from "react";
import ServiceInfoPage from "../views/pages/ServiceInfoPage";
import RudiAdditionalDocNewPage from "../views/pages/additionalDoc/RudiAdditionalDocNewPage";

export const rudiAdditionalDocRoutes = [
  {
    path: "/rudi-additional-doc",
    element: (
      <SecurityGuard doCheck={false}>
        <ServiceConfigWrapperPage serviceConfig={rudiAdditionalDocServiceConfig} wrappedPage={<ServiceInfoPage />} />
      </SecurityGuard>
    ),
  },
  {
    path: "/rudi-additional-doc/new",
    element: (
      <SecurityGuard loginOnUnauthorized={true}>
        <ServiceConfigWrapperPage
          serviceConfig={rudiAdditionalDocServiceConfig}
          wrappedPage={<RudiAdditionalDocNewPage />}
        />
      </SecurityGuard>
    ),
  },
];
